import styled from 'styled-components';

const Image = styled.img`
    width: 100%;
    max-width:400px;
    height: 100%;
    margin: 17px 0;
`;

export default Image;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Image.jsx